<div id="div_container" [class.banner]="exibindoBanner">
  <router-outlet></router-outlet>
</div>
